import { ComponentClass } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { Props } from './components/FilesHub';
import { loadItemsViewStrings } from 'owa-items-view-strings';

const lazyModule = new LazyModule(async () => {
    // We need to load the items-view strings before we invoke any of their components or functions
    const [, lazyModule] = await Promise.all([
        loadItemsViewStrings(),
        import(/* webpackChunkName: "GroupFilesHub", webpackPrefetch: true */ './lazyIndex'),
    ]);

    return lazyModule;
});

// Exported components
export const FilesHub = createLazyComponent(lazyModule, m => m.FilesHub);
export const FilesHubCommandBar = createLazyComponent(lazyModule, m => m.FilesHubCommandBar);
export const FilesHubSxSLayerView = createLazyComponent(lazyModule, m => m.FilesHubSxSLayerView);

export { ComponentClass, Props };
